<template>
  <div class="instant-discount" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar" >
      <el-form-item label="客户名称" prop="customerName">
        <el-input v-model="form.customerName" placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item label="协议编码" prop="agreementCode">
        <el-input v-model="form.agreementCode" placeholder="请输入协议编码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="customerName"
        label="客户名称"
        width="200"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="agreementCode"
        label="协议编码"
        width="160"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="totalAmount"
        label="应优惠金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="actualAmount"
        label="实际优惠金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="code"
        label="即时优惠使用规则编码"
        show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNum"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
    <el-row class="export-row" type="flex" justify="end" v-permission="'0310101'">
      <el-col :span="4">
        每页
        <el-select class="width100" v-model="exportForm.pageSize" @change="handleExportSizeChange">
          <el-option v-for="item in sizeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        条
      </el-col>
      <el-col :span="4">
        第
        <el-select class="width100" v-model="exportForm.pageNum">
          <el-option v-for="item in pageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        页
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="handleExport">导出为CSV文件</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'instantDiscountsAccount',
  data () {
    return {
      form: {
        agreementCode: '',
        customerName: ''
      },
      exportForm: {
        pageSize: 1000,
        pageNum: 1
      },
      sizeOptions: [
        {
          label: '1000',
          value: 1000
        },
        {
          label: '5000',
          value: 5000
        },
        {
          label: '10000',
          value: 10000
        },
        {
          label: '20000',
          value: 20000
        }
      ]
    }
  },
  computed: {
    ...mapGetters({ list: 'getInstantDiscountList', listState: 'getInstantDiscountListState' }),
    pageOptions () {
      const total = this.listState.total
      const size = this.exportForm.pageSize
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  methods: {
    ...mapActions(['getInstantDiscountList', 'exportInstantDiscountList']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      this.getInstantDiscountList({ ...this.form, pageNum: 1, pageSize: 10 })
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getInstantDiscountList({ pageSize: val, pageNum: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getInstantDiscountList({ pageNum: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.exportForm.pageNum = 1
    },
    // 导出
    handleExport () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportInstantDiscountList({ ...this.form, ...this.exportForm }).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '即时优惠客户使用情况报表.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style lang="scss" scoped>
.width100 {
  width: 100px;
}
.export-row {
  margin-top: 10px;
}
</style>
